import { render, staticRenderFns } from "./remember.vue?vue&type=template&id=0ebf1ae4&scoped=true&"
import script from "./remember.vue?vue&type=script&lang=ts&"
export * from "./remember.vue?vue&type=script&lang=ts&"
import style0 from "./remember.vue?vue&type=style&index=0&id=0ebf1ae4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebf1ae4",
  null
  
)

export default component.exports